var map = {
	"./_module_demo_/module.json": 275,
	"./assistant/module.json": 276,
	"./dashboard/module.json": 277,
	"./kitchen-order-ticket/module.json": 278,
	"./menu-management/module.json": 279,
	"./profile/module.json": 280,
	"./settings/module.json": 281,
	"./shop/module.json": 282
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 513;